import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, AreaChart, Area } from 'recharts';

export default function Dashboard({ metricsHistory }) {
  if (metricsHistory.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-gray-500 flex-col">
        <p className="mb-2">No data yet.</p>
        <p className="text-sm">Run the simulation to generate metrics.</p>
      </div>
    );
  }

  const lastEntry = metricsHistory[metricsHistory.length - 1];

  return (
    <div className="flex flex-col h-full bg-gray-50 p-6 overflow-auto">
      <h2 className="text-2xl font-bold mb-6">Performance Dashboard</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h3 className="text-gray-500 text-sm font-semibold uppercase mb-2">Final Throughput</h3>
          <div className="flex justify-between items-end">
            <div>
              <div className="text-3xl font-bold text-gray-800">{lastEntry.tradThroughput}</div>
              <div className="text-sm text-gray-500">Traditional (pallets/m)</div>
            </div>
            <div className="text-right">
              <div className="text-3xl font-bold text-red-600">{lastEntry.aiThroughput}</div>
              <div className="text-sm text-red-400">T-One AI (pallets/m)</div>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h3 className="text-gray-500 text-sm font-semibold uppercase mb-2">Total Wait Time</h3>
          <div className="flex justify-between items-end">
            <div>
              <div className="text-3xl font-bold text-gray-800">{lastEntry.tradWait}</div>
              <div className="text-sm text-gray-500">Traditional</div>
            </div>
            <div className="text-right">
              <div className="text-3xl font-bold text-red-600">{lastEntry.aiWait}</div>
              <div className="text-sm text-red-400">T-One AI</div>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h3 className="text-gray-500 text-sm font-semibold uppercase mb-2">Deadlock / Stop Time</h3>
          <div className="flex justify-between items-end">
            <div>
              <div className="text-3xl font-bold text-gray-800">{lastEntry.tradBlock}</div>
              <div className="text-sm text-gray-500">Traditional</div>
            </div>
            <div className="text-right">
              <div className="text-3xl font-bold text-green-600">{lastEntry.aiBlock}</div>
              <div className="text-sm text-green-500">T-One AI</div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 pb-12">
        <div className="bg-white p-6 rounded-xl shadow-sm border h-80">
          <h3 className="font-semibold mb-4 text-gray-800">Throughput Over Time</h3>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={metricsHistory} margin={{ top: 5, right: 20, bottom: 20, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="time" minTickGap={20} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="tradThroughput" name="Traditional" stroke="#6b7280" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="aiThroughput" name="T-One AI" stroke="#dc2626" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border h-80">
          <h3 className="font-semibold mb-4 text-gray-800">Traffic Congestion (Block Time)</h3>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={metricsHistory} margin={{ top: 5, right: 20, bottom: 20, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="time" minTickGap={20} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Area type="monotone" dataKey="tradBlock" name="Traditional" fill="#9ca3af" stroke="#6b7280" />
              <Area type="monotone" dataKey="aiBlock" name="T-One AI" fill="#10b981" stroke="#059669" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
